/*
 * @描叙: 错误日志
 * @作者: hanlaifu 
 * @公司: 春梅信息 
 * @创建时间: 2019-01-19 16:58:10 */

const errorLog = {
    state: {
        logs: []
    },
    mutations: {
        ADD_ERROR_LOG: (state, log) => {
            state.logs.push(log)
        }
    },
    actions: {
        addErrorLog({ commit }, log) {
            commit('ADD_ERROR_LOG', log)
        }
    }
}

export default errorLog